import { CncEditableTableFormBtn } from 'src/components/cnc-editable-table-form-btn';

export default CncEditableTableFormBtn;
